import * as __WEBPACK_EXTERNAL_MODULE__toLowerCase_index_js_61aa2a47__ from "../toLowerCase/index.js";
function searchMatch(value, search) {
    if (!search || !value) return false;
    const trimedSearch = search.trim();
    if ('' === trimedSearch) return false;
    return (0, __WEBPACK_EXTERNAL_MODULE__toLowerCase_index_js_61aa2a47__.toLowerCase)(value).includes((0, __WEBPACK_EXTERNAL_MODULE__toLowerCase_index_js_61aa2a47__.toLowerCase)(trimedSearch));
}
export { searchMatch };
